import React from 'react';
import { 
  LayoutDashboard, 
  Cpu, 
  Wallet, 
  Users, 
  ArrowUpRight, 
  ShieldCheck, 
  Sliders, 
  FileText,
  X
} from 'lucide-react';


const Sidebar = ({ activeTab, setActiveTab, isAdmin = false, isMobileOpen = false, onCloseMobile = () => {} }) => {
  const userNavItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'mt5', label: 'MT5 Accounts', icon: Cpu },
    { id: 'wallet', label: 'Wallet & Deposits', icon: Wallet },
    { id: 'referrals', label: 'Referrals', icon: Users },
    { id: 'withdrawals', label: 'Withdrawals', icon: ArrowUpRight },
  ];

  const adminNavItems = [
    { id: 'admin-dashboard', label: 'Admin Overview', icon: ShieldCheck },
    { id: 'admin-users', label: 'User Management', icon: Users },
    { id: 'admin-mt5', label: 'MT5 Approvals', icon: Cpu },
    { id: 'admin-wallet', label: 'Deposit Approvals', icon: Wallet },
    { id: 'admin-withdrawals', label: 'Withdrawals', icon: ArrowUpRight },
    { id: 'admin-rates', label: 'Profit Rates', icon: Sliders },
    { id: 'admin-reports', label: 'Financial Reports', icon: FileText },
  ];

  const navItems = isAdmin ? adminNavItems : userNavItems;

  const sidebarContent = (
    <div className="flex flex-col h-full justify-between p-4 overflow-y-auto">
      <div className="space-y-6">
        {/* Mobile Header */}
        <div className="flex items-center justify-between lg:hidden pb-3 border-b border-[#27272A]">
          <div className="flex items-center space-x-2">
            <img 
              src="/logo.png" 
              alt="DUBAI GOLD X Logo" 
              className="w-7 h-7 object-contain rounded-full shrink-0" 
            />
            <span className="text-xs font-bold uppercase text-[#FFFFFF]">DUBAI GOLD X MENU</span>
          </div>
          <button 
            onClick={onCloseMobile}
            className="p-1.5 rounded-lg text-[#9CA3AF] hover:text-[#FFFFFF] hover:bg-[#1A1A1E]"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div>
          <p className="text-[10px] font-extrabold uppercase tracking-widest text-[#9CA3AF] px-3 mb-2">
            {isAdmin ? 'ADMINISTRATION' : 'CLIENT PORTAL'}
          </p>
          <nav className="space-y-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeTab === item.id || (isAdmin && activeTab === 'dashboard' && item.id === 'admin-dashboard');
              return (
                <button
                  key={item.id}
                  onClick={() => {
                    setActiveTab(item.id);
                    onCloseMobile();
                  }}
                  className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-xl text-xs font-semibold transition-all duration-200 ${
                    isActive
                      ? 'bg-[#F97316] text-[#FFFFFF] shadow-[0_2px_15px_rgba(249,115,22,0.35)]'
                      : 'text-[#9CA3AF] hover:bg-[#1A1A1E] hover:text-[#FFFFFF]'
                  }`}
                >
                  <Icon className="w-4 h-4 shrink-0" />
                  <span className="truncate">{item.label}</span>
                </button>
              );
            })}
          </nav>
        </div>
      </div>

      <div className="p-3 bg-[#09090B] rounded-xl border border-[#27272A] mt-6 shrink-0">
        <div className="flex items-center space-x-2 text-[11px] text-[#10B981]">
          <span className="w-2 h-2 rounded-full bg-[#10B981] animate-pulse shrink-0" />
          <span className="font-bold truncate">System Status: Operational</span>
        </div>
        <p className="text-[9px] text-[#9CA3AF] mt-1">Automated MT5 Trade Copier Active</p>
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop Fixed Left Sidebar */}
      <aside className="hidden lg:block fixed left-0 top-16 bottom-0 w-64 bg-[#121215] border-r border-[#27272A] z-30">
        {sidebarContent}
      </aside>

      {/* Mobile Drawer Backdrop */}
      {isMobileOpen && (
        <div 
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-40 lg:hidden transition-opacity"
          onClick={onCloseMobile}
        />
      )}

      {/* Mobile Slide-Out Drawer */}
      <aside className={`fixed top-0 left-0 bottom-0 w-72 bg-[#121215] border-r border-[#27272A] z-50 lg:hidden transform transition-transform duration-300 ease-in-out ${
        isMobileOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        {sidebarContent}
      </aside>
    </>
  );
};

export default Sidebar;
